












// 3rd party libs
import {
    mapActions,
} from 'vuex';

// Components
import tutorial from '@webapp/components/tutorial/tutorial.vue';

// Local Types
import localEpicTypes from '@webapp/store/types.js';
import {
    TUTORIAL_NAMES,
} from '@webapp/store/modules/tutorial';


export default {
    name: 'leaderboards-intro-sheet',
    components: {
        tutorial,
    },
    data() {
        return {
            tutorialName: TUTORIAL_NAMES.LEADERBOARDS_INTRO_TUTORIAL,
            steps: [
                {
                    image: require('@webapp/modules/rewards/assets/images/leaderboards/intro/step1.webp'),
                    title: this.$t('rewards.leaderboardIntro.step1.title'),
                    text: this.$t('rewards.leaderboardIntro.step1.text'),
                    buttonText: this.$t('tutorial.next'),
                    automationText: 'leaderboards-intro-sheet-step1',
                }, {
                    image: require('@webapp/modules/rewards/assets/images/leaderboards/intro/step2.webp'),
                    title: this.$t('rewards.leaderboardIntro.step2.title'),
                    text: this.$t('rewards.leaderboardIntro.step2.text'),
                    buttonText: this.$t('tutorial.finish'),
                    automationText: 'leaderboards-intro-sheet-step2',
                },
            ],
        };
    },
    methods: {
        ...mapActions({
            resetModal: localEpicTypes.RESET_MODAL,
        }),
    },
};
